
require.register("babel-runtime/node_modules/core-js/library/modules/_is-object.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "babel-runtime/node_modules/core-js");
  (function() {
    module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
  })();
});